// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2990":"be1e39a9e6f3e61c127c","6698":"92c4fed18dc554aa726a"}[chunkId] + ".css";
};